import getTimeRemaining from './getTimeRemaining';

const getFormatDateWithDaysAgo = (date: Date) => {

	const getTimeRemainingObject = getTimeRemaining(date);
	const { days } = getTimeRemainingObject;
	const daysAgo = days < 0 ? days * -1 : days;
	const daysAgoOneDayTextCheck = daysAgo === 1 ? 'day' : 'days';

	const newDate = new Date(date);
	const day = newDate.getDate();
	const month = newDate.toLocaleString('en-us', { month: 'short' });
	const year = newDate.getFullYear();
	const formatDate = `${month} ${day}, ${year}`;
	const today = new Date();

	if (days === 0 || (days === -1 && day === today.getDate())) {

		return 'Today';

	}

	const formatDateMessage = daysAgo < 7 ? `${daysAgo} ${daysAgoOneDayTextCheck} ago` : formatDate;

	return formatDateMessage;

};

export default getFormatDateWithDaysAgo;
